import { colors, fontSizes } from '../../../consts'
import { styled } from '@mui/system'

export const StatusText = styled('div')(({ theme }) => ({
  fontSize: fontSizes.xSmall,
  fontWeight: 'bold',
  color: colors.gray.gray75,
  margin: theme.spacing(1, 2, 0),
  [theme.breakpoints.down('sm')]: {
    margin: theme.spacing(1, 2),
  },
}))
